import { Route, Routes } from "react-router-dom";
import { useFeatureFlags } from "@/config/useFeatureFlags";
import { Shell } from "@/components/shell/Shell";
import { LandingRedirect } from "@/components/shell/LandingRedirect";
import { RequestListScreen } from "@/features/requestList/RequestListScreen";
import { TaskEfficiencyScreen } from "@/features/taskEfficiency/TaskEfficiencyScreen";
import { ThroughputScreen } from "@/features/throughput/ThroughputScreen";
import { JourneyDetailScreen } from "@/features/journeyDetail/JourneyDetailScreen";
import { OperationsScreen } from "@/features/operations/OperationsScreen";
import { InfoScreen } from "@/features/info/InfoScreen";
import { QaScreen } from "@/features/qa/QaScreen";

export default function App() {
  const flags = useFeatureFlags();
  return (
    <Shell>
      <Routes>
        {/* Operations for people who have the flag, Requests for everyone else (decided once the flags load). */}
        <Route path="/" element={<LandingRedirect />} />
        <Route path="/requests" element={<RequestListScreen />} />
        {/* One consultant journey on one page, entered from a request (any user) or from an intake (Operations). */}
        <Route path="/requests/:id" element={<JourneyDetailScreen />} />
        <Route path="/tasks" element={<TaskEfficiencyScreen />} />
        {flags.throughput && (
          <Route path="/throughput" element={<ThroughputScreen />} />
        )}
        {flags.operations && (
          <Route path="/intake/:source/:id" element={<JourneyDetailScreen />} />
        )}
        {flags.operations && (
          <Route path="/operations" element={<OperationsScreen />} />
        )}
        <Route path="/info" element={<InfoScreen />} />
        {/* Hidden QA screen — raw Cosmos source data. Unlinked; reachable only by typing the URL. */}
        <Route path="/qa/:requestId" element={<QaScreen />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Shell>
  );
}

function NotFound() {
  return (
    <main className="screen">
      <h1>Not found</h1>
      <p>The page you requested doesn&apos;t exist.</p>
    </main>
  );
}
